<template lang="pug">
v-menu(v-model="menuStatus" :close-on-content-click="false" location="bottom start" origin="auto")
	template(v-slot:activator="{props}")
		v-text-field(
			v-bind="props"
			:model-value="inputValue"
			append-inner-icon="mdi-menu-down"
			readonly
			:label="$t('form_labels.participants', 'Partecipanti')"
			:class="$attrs.class"
			@click:append-inner="menuStatus = true"
		)
			template(v-slot:prepend-inner)
				v-icon(icon="mdi-account-outline" color="accent" @click='menuStatus = true')
	v-list(class='tw-w-full')
		v-list-item(v-for='pType in participantTypes' :key='pType.value')
			div(class="tw-flex tw-items-center")
				div.counter-label(class="tw-flex-1")
					span.tw-font-bold {{ pType.label }}
					v-icon(v-if='pType.click' size="x-small" @click="pType.click" icon="mdi-information-outline")
				div(class="tw-flex tw-items-center tw-gap-2")
					div.counter-btn(v-on:click="decrement(pType.value)" :class="disableMinusButton[pType.value]")
						v-icon(icon="mdi-minus" )
					span.counter-value.tw-font-bold {{ $props[pType.value] }}
					div.counter-btn(v-on:click="increment(pType.value)")
						v-icon(icon="mdi-plus")
</template>

<script setup>
import { computed, ref } from 'vue';
import {useI18n} from "vue-i18n";


const i18n = useI18n();
const participantTypes = [
	{label: i18n.t('common.adult', 1), value: 'adults'}, 
	{label: i18n.t('common.children', 1), value: 'children', click: () => openInfo() }
];
const menuStatus = ref(false);
const props = defineProps(['adults', 'children']);
const emit = defineEmits(['update:adults', 'update:children']);
const inputValue = computed(() => {
	let text = [];
	if(props.adults > 0) text.push(props.adults + ' ' + (props.adults === 1 ? i18n.t('common.adult', 0) : i18n.t('common.adult', 1)));
	if(props.children > 0) text.push(props.children + ' ' + (props.children === 1 ? i18n.t('common.children', 0) : i18n.t('common.children', 1)));
	return text.join(', ');
});
const disableMinusButton = computed(() => {
	let p = [];
	for(const pType of participantTypes) {
		const otherType = 'adults' == pType.value ? 'children' : 'adults';
		p[pType.value] = (!props[pType.value] || (1 == props[pType.value] && !props[otherType])) ? 'counter-btn--disabled' : '';
	}
	return p;
});


function decrement(pType){
	const otherType = 'adults' == pType ? 'children' : 'adults';
	if (1 === props[pType] && 0 === props[otherType]) return;
	if(!props[pType]) return;
	emit('update:'+pType, props[pType] - 1);
}
function increment(pType){
	emit('update:'+pType, props[pType] + 1);
}
function openInfo() {
	window.open(i18n.t('links.children_policy_link', 'https://www.trenitalia.com/it/html/trenitalia/Info_regionale.html'), i18n.t('form_labels.children_info', 'Info Ragazzi'), "height=450,width=600");
}
</script>

<style scoped>
.counter-btn{
	border-radius: 50%;
	border: solid 1px var(--color-accent);
	cursor: pointer;
}

.counter-btn.counter-btn--disabled{
	--v-theme-on-surface: #dfdfdf;
	border: solid 1px #dfdfdf;
	cursor: initial;
}
.counter-value{
}


</style>